module.exports = __webpack_public_path__ + "static/img/ikonaTabela-OFF.b49a6e69.png";